import { render, staticRenderFns } from "./selectGroup.vue?vue&type=template&id=088ebdbe"
import script from "./selectGroup.vue?vue&type=script&lang=js"
export * from "./selectGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports